import { Component } from 'preact';
import { Icon } from '../icons.js';
import { Builder } from './builder.js';
import { uploadArtwork } from '../../lib/api.js';
import { DesignPart } from '../../../common/data/designs.js';

export interface LogoUploadButtonProps {
	builder: Builder;
	setError: (error?: string) => void;
	done?: (part: DesignPart) => void;
	title?: string;
}

interface LogoUploadButtonState {
	active?: boolean;
}

export class LogoUploadButton extends Component<LogoUploadButtonProps, LogoUploadButtonState> {

	render(props: LogoUploadButtonProps, { active }: { active: boolean }) {
		return <div className={`logo-upload builder-settings__part-switch ${active ? 'logo-upload--active' : ''}`}>
			<input
				id="logoUpload"
				type="file"
				onChange={e => this.uploadLogo(e.target as HTMLInputElement)}
				accept="application/postscript,application/pdf,image/svg+xml,image/png,image/jpeg,.eps,.pdf,.ai,.svg,.png,.jpg,.jpeg"
				onClick={e => (e.target as HTMLInputElement).value = '' }
			/>
			<label for="logoUpload">
				<Icon name="image-file" />
				<span>{props.title || 'Upload logo'}</span>
			</label>
		</div>;
	}

	async uploadLogo(input: HTMLInputElement) {

		const file = input.files?.[0];
		if (!file) return;

		this.setState({ active: true });
		await uploadArtwork({ file })
			.then(res => {
				this.props.setError(undefined);
				this.props.builder.closeDialog();
				const part = this.props.builder.manager.addUpload(res.upload);
				this.props.builder.selectPart(part.id);
				this.props.done?.(part);
			})
			.catch(e => this.props.setError(e.message || 'Unknown error'));

		this.setState({ active: false });

	}

}
